"use client";
import { useState } from "react";
import InputField from "../../../components/common/InputField";
import RaidoField from "../../../components/common/RaidoField";
import SelectInput from "../../../components/Select";

const CreateTicketModal = () => {
  const [mode, setMode] = useState("low");
  return (
    <div className="w-[655px] p-4">
      <div className="grid grid-cols-6 gap-4">
        <InputField
          className="col-span-6"
          label="Subject"
          type="text"
          placeholder="Ramesh Sharma"
        />
        <SelectInput
          className="col-span-3"
          label="Category"
          name={""}
          selectOptions={[]}
        />
        <div className="col-span-3">
          <RaidoField
            label="Priority"
            value={mode}
            onClick={(val) => {
              if (typeof val === "string") {
                setMode(val);
              }
            }}
            valuesArr={[
              { value: "low", text: "Low" },
              { value: "medium", text: "Medium" },
              { value: "high", text: "High" },
            ]}
          />
        </div>
        <ul className="col-span-6 text-[#1E293B] text-sm font-medium list-disc px-4">
          <li>Download the Excel/CSV template before uploading.</li>
          <li>Do not change column headers.</li>
          <li>Mandatory fields: Sender, Receiver, Reference, etc.</li>
        </ul>
      </div>
    </div>
  );
};

export default CreateTicketModal;
